import { counters } from '../domain/engine'
import type { Ticket } from '../domain/types'

export function ProgressBar({ tickets, showLabel = true }: { tickets: Ticket[]; showLabel?: boolean }) {
  const c = counters(tickets)
  const pct = (n: number) => (c.total ? (n / c.total) * 100 : 0)
  return (
    <div className="fz-prog">
      <div className="fz-prog__bar" role="group" aria-label="Progresso do atendimento">
        {c.completos > 0 && (
          <div
            className="fz-prog__seg fz-prog__seg--done"
            style={{ width: pct(c.completos) + '%' }}
            title={`${c.completos} concluído${c.completos !== 1 ? 's' : ''}`}
            role="img"
            aria-label={`${c.completos} concluídos`}
          />
        )}
        {c.emAtendimento > 0 && (
          <div
            className="fz-prog__seg fz-prog__seg--active"
            style={{ width: pct(c.emAtendimento) + '%' }}
            title={`${c.emAtendimento} em atendimento`}
            role="img"
            aria-label={`${c.emAtendimento} em atendimento`}
          />
        )}
        {c.aguardando > 0 && (
          <div
            className="fz-prog__seg fz-prog__seg--pending"
            style={{ width: pct(c.aguardando) + '%' }}
            title={`${c.aguardando} aguardando`}
            role="img"
            aria-label={`${c.aguardando} aguardando`}
          />
        )}
        {c.cancelados > 0 && (
          <div
            className="fz-prog__seg fz-prog__seg--canceled"
            style={{ width: pct(c.cancelados) + '%' }}
            title={`${c.cancelados} cancelado${c.cancelados !== 1 ? 's' : ''}`}
            role="img"
            aria-label={`${c.cancelados} cancelados`}
          />
        )}
      </div>
      {showLabel && <span className="fz-prog__label">{c.completos}/{c.total}</span>}
    </div>
  )
}

export function ProgressDonut({ tickets }: { tickets: Ticket[] }) {
  const c = counters(tickets)
  const resolved = c.completos + c.cancelados
  const frac = c.total ? resolved / c.total : 0
  const pct = Math.round(frac * 100)
  const RAD = 28, CIRC = 2 * Math.PI * RAD
  const off = CIRC * (1 - frac)
  return (
    <div className="fz-donut">
      <svg width="64" height="64" viewBox="0 0 64 64">
        <circle cx="32" cy="32" r={RAD} fill="none" stroke="var(--color-hairline)" strokeWidth="6" />
        <circle cx="32" cy="32" r={RAD} fill="none" stroke="var(--color-success)" strokeWidth="6"
          strokeDasharray={CIRC} strokeDashoffset={off} strokeLinecap="round" transform="rotate(-90 32 32)"
          style={{ transition: 'stroke-dashoffset 400ms var(--ease-standard)' }} />
      </svg>
      <div className="fz-donut__num"><span className="fz-donut__pct">{pct}%</span></div>
    </div>
  )
}
